module.exports = __webpack_public_path__ + "img/tipoDocumentos.a3ec3b8e.svg";